import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from '../HeaderControls/index.module.scss';

export const ThemeSwitcher = () => {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.global.theme);
  const { i18n } = useTranslation();
  const dark = theme === 'dark';
  const zh = i18n.language?.startsWith('zh');
  const label = zh
    ? (dark ? '切换到浅色主题' : '切换到深色主题')
    : (dark ? 'Switch to light theme' : 'Switch to dark theme');

  const toggleTheme = () => {
    dispatch({ type: 'global/setTheme', payload: dark ? 'light' : 'dark' });
  };

  return (
    <button type="button" className={styles.control} onClick={toggleTheme} title={label} aria-label={label}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {dark ? <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /> : <>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </>}
      </svg>
    </button>
  );
};
